/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class StripeService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Handle Stripe webhook events
   * @param requestBody
   * @returns any Webhook received successfully
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesStripeWebhook(
    requestBody?: Record<string, any>,
  ): CancelablePromise<{
    received?: boolean;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/stripe/webhook',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - invalid signature`,
      },
    });
  }

}
